import {useResourcesToken} from '@/di/di.root-container.hooks';

import {ReactNode} from 'react';

import {useUserStore} from '@/stores/connectors';
import {Layout} from '@/ui/kit/Layout/Layout';
import {MainContainer} from '@/ui/kit/MainContainer/MainContainer';

import s from './ClickerPageContainerWithBackground.module.css';

interface Props {
  children?: ReactNode | undefined;
}

export function ClickerPageContainerWithBackground({children}: Props): JSX.Element {
  const {locations} = useResourcesToken().content.ClickerContainer;
  const userStore = useUserStore();

  return (
    <Layout enableDiv100vh>
      <MainContainer>
        <div className={s.customContainer} style={{background: locations[userStore.getLocationType()]}}>
          {children}
        </div>
      </MainContainer>
    </Layout>
  );
}
